import { defineStore } from 'pinia';
import axios from 'axios';

const API_URL = {
    // get: return count + IDs
    // post: add new
    // delete: /{id}/
    compare: '/api/v2/land/auctions/compare/',
    favorite: '/api/v2/land/auctions/favorites/',
};

// eslint-disable-next-line import/prefer-default-export
export const useListCompareFavoriteStore = defineStore('listCompareFavorite', {
    state: () => ({
        compare: [],
        favorite: []
    }),
    getters: {
        compareCount: (state) => (state.compare.length),
        favoriteCount: (state) => (state.favorite.length),
    },
    actions: {
        setCompare(data) {
            this.compare = data;
        },
        setFavorite(data) {
            this.favorite = data;
        },
        async getItems(type) {
            const urlByType = type === 'compare' ? API_URL.compare : API_URL.favorite;
            const fnByType = type === 'compare' ? this.setCompare : this.setFavorite;
            return axios.get(urlByType).then(({ data }) => {
                    if (data.success) {
                        fnByType(data.data);
                    } else {
                        console.log(data.message);
                    }
                })
                .catch((error) => {
                    console.error(error);
                });
        },
        async toggleItem(type, id) {
            const method = this[type].includes(id) ? 'delete' : 'post';
            const urlByType = method === 'delete' ? `${API_URL[type] + id}/` : API_URL[type];
            let reqBody = {};
            if (method !== 'delete') {
                reqBody = new FormData();
                reqBody.append('ID', +id);
            }
            const afterFn = method === 'delete' ? this.deleteFromCollection : this.addToCollection;
            return axios({
                method,
                url: urlByType,
                data: reqBody
            }).then(({ data }) => {
                if (data.success) {
                    afterFn(type, id);
                } else {
                    console.log(data.message);
                }
            })
                .catch((error) => {
                    console.error(error);
                });
        },
        deleteFromCollection(type, id) {
            const idx = this[type].indexOf(id);
            if (idx >= 0) {
                this[type].splice(idx, 1);
            }
        },
        addToCollection(type, id) {
            this[type].push(id);
        }

    }
});
